import { getterTypes } from '@/core/constants'

function montaAbas() {
	return [
		{
			id: 'concluido',
			titulo: 'Concluídos',
			isVisivel: true,
			textoListagemVazia: {
				mensagem: 'Você não possui <strong>pedido de utilização</strong> em andamento',
			},
		},
		{
			id: 'emAndamento',
			titulo: 'Em Andamento',
			isVisivel: false,
			textoListagemVazia: {
				mensagem: 'Você não possui <strong>pedido de utilização</strong> em andamento',
			},
		},
	]
}
export default {
	[getterTypes.ATA.GESTAO_PEDIDOS.ABAS_INTERNAS_GESTAO_PEDIDOS]: () => montaAbas(),
}
